import React from 'react';
import {
  Box,
  Typography,
  Breadcrumbs,
  Link,
  Container,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Home as HomeIcon } from '@mui/icons-material';

export const DeliverablesSandboxPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="xl">
      <Box sx={{ py: 4 }}>
        {/* Breadcrumb */}
        <Breadcrumbs sx={{ mb: 3 }}>
          <Link
            color="inherit"
            href="/"
            onClick={(e) => {
              e.preventDefault();
              navigate('/');
            }}
            sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
          >
            <HomeIcon sx={{ mr: 0.5 }} fontSize="small" />
            Home
          </Link>
          <Link
            color="inherit"
            href="/admin/hub"
            onClick={(e) => {
              e.preventDefault();
              navigate('/admin/hub');
            }}
            sx={{ cursor: 'pointer' }}
          >
            Admin Hub
          </Link>
          <Typography color="text.primary">Deliverables Sandbox</Typography>
        </Breadcrumbs>

        {/* Header */}
        <Box sx={{ mb: 4 }}>
          <Typography variant="h4" component="h1" gutterBottom>
            Deliverables Sandbox
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Test and experiment with deliverables features in a safe environment.
          </Typography>
        </Box>
      </Box>
    </Container>
  );
};
